import { isNil } from 'ramda';

import { IntNumber } from './NumberTypes/IntNumber';

export class ReactivePower {
  private constructor(
    private value: IntNumber,
    private unit: 'VAr' | 'kVAr' = 'VAr'
  ) {
    this.value = value;
    this.unit = unit;
  }

  static fromVarNumber(value?: number) {
    return new ReactivePower(IntNumber.fromNumber(value));
  }

  addTo(other: ReactivePower) {
    const thisReactivePowerVar = this.toVar();
    const otherReactivePowerVar = other.toVar();
    const reactivePowerSum = ReactivePower.fromVarNumber(
      thisReactivePowerVar.value.addTo(otherReactivePowerVar.value)
    );

    return reactivePowerSum;
  }

  toKilo() {
    if (this.unit !== 'kVAr') {
      const currentValue = this.value.toNumber();
      if (isNil(currentValue))
        return new ReactivePower(IntNumber.fromNumber(currentValue), 'kVAr');

      return new ReactivePower(
        IntNumber.fromNumber(currentValue / 1000),
        'kVAr'
      );
    }
    return this;
  }

  toVar() {
    if (this.unit === 'kVAr') {
      const currentValue = this.value.toNumber();
      if (isNil(currentValue))
        return new ReactivePower(IntNumber.fromNumber(currentValue), 'VAr');

      return new ReactivePower(
        IntNumber.fromNumber(currentValue * 1000),
        'VAr'
      );
    }
    return this;
  }

  toString() {
    const value = this.value.toFixedNumber();
    return !isNil(value) ? `${value} ${this.unit}` : 'N/A';
  }
}
